import axios from "axios";
// import { auth } from '@/utils';
import { Toast } from "vant";
// import router from '@/router';

axios.defaults.timeout = 1000 * 60;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 创建axios实例
const service = axios.create({
  // 根据不同env设置不同的baseURL
  // baseURL: process.env.VUE_APP_BASE_URL,
  baseURL: "https://zsrbactivity.zsnews.cn",
});

// axios实例拦截请求
service.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      // ...auth.headers(), // 你的自定义headers，如token等
    };
    // showLoadingToast({
    //   forbidClick: true,
    //   message: '加载中...',
    // });
    return config;
  },
  (error) => {
    // closeToast();
    return Promise.reject(error);
  }
);

// axios实例拦截响应
service.interceptors.response.use(
  // 2xx时触发
  (response) => {
    // closeToast();
    console.log(response.data);
    // response.data就是后端返回的数据，结构根据你们的约定来定义
    const { code, msg } = response.data;
    let errMessage = "";
    switch (code) {
      case 1:
        break;
      case 0:
        errMessage = msg;
        // router.go(-1);
        break;
      default:
        errMessage = msg;
        break;
    }
    if (errMessage) Toast(errMessage);
    return response;
  },
  // 非2xx时触发
  (error) => {
    Toast.fail("网络错误，请稍后重试");
    return Promise.reject(error);
  }
);

export default service;
